export async function promoteAgent(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, agentUri, signer } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for promoteAgent operation.');
    }
    const simpleApp = appRegistryDapp.callApp(appAddress);
    const callData = simpleApp.interface.encodeFunctionData('promoteAgent', [agentUri, []]);
    return smartAccount.sendUserOp({
        toAddress: [appAddress],
        callData: [callData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
